import { CardFinish } from 'utils/finishes';

/**
 * Entry defaults: what a card is added as from the collection toolbar.
 * Conditions and languages use the frontend codes ('NM', 'EN'); finishes use
 * the card-level lowercase form. Mapping to wire values happens at the API edge.
 */
export type EntryCondition = 'NM' | 'LP' | 'MP' | 'HP';

export const ENTRY_CONDITIONS: readonly EntryCondition[] = ['NM', 'LP', 'MP', 'HP'];

/** A physical copy has one condition, one finish, one language. */
export interface HaveEntryDefaults {
  condition: EntryCondition;
  finish: CardFinish;
  language: string;
}

/** A want accepts sets of each; these ARE the Settings version defaults. */
export interface WantEntryDefaults {
  conditions: string[];
  finishes: CardFinish[];
  languages: string[];
}

export const HAVE_LIST_STOCK_DEFAULTS: HaveEntryDefaults = {
  condition: 'NM',
  finish: 'nonfoil',
  language: 'EN',
};

/**
 * What a new account's Want List accepts: the stored defaults of an untouched
 * UserWantListSettings row (NM to MP, every finish, the eleven languages). It is
 * both the "is this stock?" reference for the pill and Reset's target, so it has
 * to match the server default exactly: an English-only stock would paint every
 * untouched account as changed and make Reset silently drop ten languages. Also
 * the fallback every Want List surface uses when the defaults have not loaded.
 */
export const WANT_LIST_STOCK_DEFAULTS: WantEntryDefaults = {
  conditions: ['NM', 'LP', 'MP'],
  finishes: ['nonfoil', 'foil', 'etched'],
  languages: ['EN', 'ES', 'FR', 'DE', 'IT', 'PT', 'JA', 'KO', 'RU', 'ZHS', 'ZHT'],
};

export const ENTRY_DEFAULTS_SAVE_DEBOUNCE_MS = 400;

/** Below this viewport width the pill abbreviates and the editor is a bottom sheet. */
export const ENTRY_DEFAULTS_COMPACT_BELOW_PX = 640;
